import {issuers} from '@apps-common/auth';
import {APPS, ENVIRONMENTS} from '@apps-common/ui-components/apps.jsx';
import {LicenseInfo} from '@mui/x-license';

// Environments -----------------------------------------------------------

// Note that staging in this context means internal (static) and does not mean
// staging auth/API

// TODO: export types from apps-common/ui-components
export const DEPLOY_ENV: 'staging' | 'production' =
  (import.meta.env.VITE_DEPLOY_ENV as 'staging' | 'production') ??
  ENVIRONMENTS.staging;

export const isDev = import.meta.env.MODE === 'development';

// Authentication ---------------------------------------------------------

export const AUTH_ISSUER =
  import.meta.env.VITE_AUTH_ISSUER ?? issuers.production;

export const AUTH_CLIENT_ID =
  import.meta.env.VITE_AUTH_CLIENT_ID ??
  import.meta.env.VITE_AUTH_CLIENT_ID_PROD_DEV;

// LaunchDarkly -----------------------------------------------------------

export const LD_CLIENTSIDE_ID =
  import.meta.env.VITE_LD_CLIENTSIDE_ID ??
  {
    production: import.meta.env.VITE_LD_CLIENTSIDE_ID_PROD,
    staging:
      import.meta.env.VITE_LD_CLIENTSIDE_ID_STAGING ??
      '662b9f3a0a3e70106fd55f61',
    local: '662b9f49db0cc60fb29d0302',
  }[isDev ? 'local' : DEPLOY_ENV];

// Mapbox -----------------------------------------------------------------

// demo mapbox access token only works on localhost
export const MAPBOX_ACCESS_TOKEN =
  import.meta.env.VITE_MAPBOX_ACCESS_TOKEN ||
  'pk.eyJ1IjoicGxhbmV0IiwiYSI6ImNtNmF5bm1tZDAydGkya3B4NjI1NHM0NHIifQ.JN9OKpu_ocjgWGC0P6moCA';

// geocoder -----------------------------------------------------------------

export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

// MUI X license ----------------------------------------------------------

LicenseInfo.setLicenseKey(import.meta.env.VITE_MATERIAL_UI_X_KEY);

// External links ---------------------------------------------------------

export const FEATURES_MANAGER_URL =
  import.meta.env.VITE_FEATURES_MANAGER_URL ??
  APPS.featuresManager.href[DEPLOY_ENV];

export const EXPLORER_URL =
  import.meta.env.VITE_EXPLORER_URL ?? APPS.explorer.href[DEPLOY_ENV];

export const DATA_COLLECTIONS_URL =
  import.meta.env.VITE_DATA_COLLECTIONS_URL ??
  APPS.dataCollections.href[DEPLOY_ENV];

export const BROWSER_URL =
  import.meta.env.VITE_BROWSER_URL ?? APPS.browser.href[DEPLOY_ENV];

export const ACCOUNT_URL =
  import.meta.env.VITE_ACCOUNT_URL ?? APPS.account.href[DEPLOY_ENV];

export const TASKING_URL =
  import.meta.env.VITE_TASKING_URL ?? APPS.tasking.href[DEPLOY_ENV];

export const STORIES_URL =
  import.meta.env.VITE_STORIES_URL ?? APPS.stories.href[DEPLOY_ENV];

export const DATA_APP_URL = APPS.data.href[DEPLOY_ENV];

export const ACCOUNT_APP_URL = import.meta.env.VITE_ACCOUNT_APP_URL;

export const SH_DATA_COLLECTIONS_URL =
  'https://apps.sentinel-hub.com/dashboard/#/collections/';
export const INSIGHTS_DATA_COLLECTIONS_URL = `${APPS.dataCollections.href[DEPLOY_ENV]}#/`;

export const CONFIGURATION_APP_URL = APPS.configurationManager.href[DEPLOY_ENV];

export const NOTIFICATIONS_ENV =
  AUTH_ISSUER === issuers.production
    ? ENVIRONMENTS.production
    : ENVIRONMENTS.staging;

// webp support check ---------------------------------------------------------

export const PLANET_TILE_SERVER_ENCODINGS = {
  jpg: true,
  png: true,
} as const;

//ToDo: revisit and uncomment or delete once we kow the future of webp

// function check_webp_feature(feature, callback) {
//   const kTestImages = {
//     lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
//     lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
//     alpha:
//       'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
//     animation:
//       'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
//   };
//   const img = new Image();
//   img.onload = function () {
//     callback(feature, img.width > 0 && img.height > 0);
//   };
//   img.onerror = function () {
//     callback(feature, false);
//   };
//   img.src = 'data:image/webp;base64,' + kTestImages[feature];
// }

// check_webp_feature('alpha', (feature, supported) => {
//   PLANET_TILE_SERVER_ENCODINGS.webp = supported;
// });
